import React from 'react';
import { CreateNoteButton } from '@/components/buttons/viewHeaderButtons/CreateNoteButton';
import { CreateTaskButton } from '@/components/buttons/viewHeaderButtons/CreateTaskButton';
import { CreateRelationshipContactButton } from '@/components/buttons/viewHeaderButtons/CreateRelationshipContactButton';
import { TabView } from '@/components/layouts/TabView';
import { useTheme } from '@mui/material';
import { getRelationshipCompanyTabs } from '@/app/tabs';
import { ClientBrandIcon } from '@/components/icons/ClientBrandIcon';
import { RelationshipsIcon } from '@/components/icons/RelationshipsIcon';
import { useGetRelationshipCompanyContactData } from '@/hooks/useGetRelationshipCompanyContactData';

const HEADER_COMPONENTS = {
	'': CreateRelationshipContactButton,
	notes: CreateNoteButton,
	tasks: CreateTaskButton,
};

export const RelationshipCompanyTabView = () => {
	const theme = useTheme();
	const { logoDomain, subtitle } = useGetRelationshipCompanyContactData();

	return (
		<TabView
			objectType='relationshipCompany'
			getTabs={getRelationshipCompanyTabs}
			headerComponents={HEADER_COMPONENTS}
			icon={
				<ClientBrandIcon
					domain={logoDomain}
					height='55px'
					width='55px'
					fallbackIcon={
						<RelationshipsIcon
							width='55px'
							height='55px'
							{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
						/>
					}
				/>
			}
			subtitle={subtitle}
		/>
	);
};
